import startTimers from "../modules/Timer";

startTimers()

window.addEventListener('load', () => {
    let promoCodeBlocks = document.querySelectorAll('.promo-code-block');

    if (promoCodeBlocks == null) {
        return;
    }

    promoCodeBlocks.forEach(promoCodeBlock => {

        let copyTooltip = null;
        try {
            createTooltip(promoCodeBlock)

            copyTooltip = bootstrap.Tooltip.getOrCreateInstance(promoCodeBlock)
        } catch (error) {
            console.log(error)
        }

        promoCodeBlock.addEventListener('click', () => {

            let element = document.querySelector('.promo-code')

            // Create a fake `textarea` and set the contents to the text
            // you want to copy
            const storage = document.createElement('textarea');

            storage.value = element.innerText;
            element.appendChild(storage);

            // Copy the text in the fake `textarea` and remove the `textarea`
            storage.select();
            storage.setSelectionRange(0, 99999);

            document.execCommand('copy');
            element.removeChild(storage);


            try {
                copyTooltip.show()

                setTimeout(() => {
                    copyTooltip.hide()
                }, 2000)
            } catch (error) {
                console.log(error)
            }
        })
    })
})
